import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const headers = getAuthHeaders().headers
const resolveBuildingId = input => {
  if (!input) return null
  if (typeof input === 'number') return input
  if (typeof input === 'string' && input.trim()) {
    const numeric = Number(input)
    return Number.isFinite(numeric) ? numeric : null
  }
  if (typeof input === 'object') {
    if (typeof input.buildingId === 'number') return input.buildingId
    if (typeof input.buildingId === 'object') return resolveBuildingId(input.buildingId)
    if (typeof input.building === 'number') return input.building
    if (typeof input.building === 'object') return resolveBuildingId(input.building)
    if (typeof input.id === 'number') return input.id
  }
  return null
}

export const findAll = async params => {
  const buildingId = resolveBuildingId(params)
  if (!buildingId) {
    return {
      ok: false,
      status: 400,
      message: 'Debe indicar el identificador del edificio.',
    }
  }
  try {
    const response = await tuApptoAPI.get(`/apartments/findall/${buildingId}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return (
      error?.response?.data || {
        ok: false,
        status: 500,
        message: 'Error al obtener los apartamentos.',
      }
    )
  }
}

export const create = async request => {
  try {
    const response = await tuApptoAPI.post('/apartments/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const update = async request => {
  try {
    const response = await tuApptoAPI.put('/apartments/update', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const remove = async id => {
  try {
    const response = await tuApptoAPI.delete(`/apartments/remove/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}
